<template>
  <base-table-wrapper>
    <template #top-button>
    </template>
    <template #filtering>
      <div class="text-right">
        <button v-if="isFilteringVisible"
                type="button"
                class="btn btn-sm fa fa-sync fa-lg btn-link"
                @click="clearFilters()">
        </button>
        <b-button aria-controls="task_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.task_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="task_search_collapse" class="mt-2" @input="isFilteringVisible = $event">
          <tasks-filtering ref="filtering" @searchParams="setSearchParams($event)"></tasks-filtering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Table :searchParams="searchParams"></Table>
    </template>
  </base-table-wrapper>
</template>

<script>
import Table from './Table'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import TasksFiltering from '@/components/Dashboard/Views/excmtask/components/TasksFiltering/TasksFiltering'

export default {
  name: 'List',
  components: {
    Table,
    BaseTableWrapper,
    TasksFiltering
  },
  data () {
    return {
      isFilteringVisible: false,
      searchParams: {}
    }
  },
  methods: {
    clearFilters () {
      this.$refs.filtering.$data.filters = {
        idCase: '',
        idTaskType: [],
        'lastPoolTask.operation': '',
        state: null,
        started: null,
        finished: null, // if started = 0 then finished = 1
        'lastPoolTask.operationTransferUserData': null,
        'idCase.contractorUserData': null,
        filterTaskByCustomField: '',
        taskFilterByProgress: null
      }
      this.$refs.filtering.$data.currentTaskType = []
    },
    setSearchParams (filters) {
      this.searchParams = filters
    }
  }
}
</script>
